import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import type { HeaderContext } from "@tanstack/react-table";

export const MaxHeader = ({ column }: HeaderContext<any, unknown>) => {
  return (
    <DataTableColumnHeader
      column={column}
      title="Max"
      style={{ padding: "5px" }}
    />
  );
};
